import { RouteConfig } from 'vue-router';
import { ROUTE_NAME } from './constant';

export const routes: RouteConfig[] = [
    {
        path: '/triangle/index/:activityId',
        name: ROUTE_NAME.INDEX,
        meta: {
            title: '报名',
        },
        component: () => import(/* webpackChunkName: "triangle" */ './pages/index.vue'),
    },
    {
        path: '/triangle/home/:activityId/',
        name: ROUTE_NAME.HOME,
        meta: {
            title: '铁三角',
        },
        component: () => import(/* webpackChunkName: "triangle" */ './pages/home.vue'),
    },
    {
        path: '/triangle/invitation/:activityId/:userId/:groupId',
        name: ROUTE_NAME.INVITATION,
        meta: {
            title: '铁三角',
        },
        component: () => import(/* webpackChunkName: "triangle" */ './pages/invitation.vue'),
    },
];
